import { render, staticRenderFns } from "./DocumentAttachmentDetailInput.vue?vue&type=template&id=3b872bb0&scoped=true"
import script from "./DocumentAttachmentDetailInput.vue?vue&type=script&lang=js"
export * from "./DocumentAttachmentDetailInput.vue?vue&type=script&lang=js"
import style0 from "./DocumentAttachmentDetailInput.vue?vue&type=style&index=0&id=3b872bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b872bb0",
  null
  
)

export default component.exports